export default "__VITE_ASSET__Bv1N9x6W__"